module.exports = __webpack_public_path__ + "img/127.2.73009ef4.png";